module.exports = __webpack_public_path__ + "static/media/soundcloud-social-media-svgrepo-com.b3c74ffe.svg";